import { render, staticRenderFns } from "./BagsHero.vue?vue&type=template&id=7dd19b2e&scoped=true"
var script = {}
import style0 from "./BagsHero.vue?vue&type=style&index=0&id=7dd19b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd19b2e",
  null
  
)

export default component.exports